import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';
import { Socio } from '../../model/socio';
import { Imagen } from '../../model/imagen';
import { Resultado } from '../../model/resultado';
import { DocumentoEntrada } from '../../model/documento-entrada';
import { DocumentoDetalleEntrada } from '../../model/documento-detalle-entrada';
import { SucursalService } from '../../services/sucursal.service';
import { DocumentoEntradaService } from '../../services/documento-entrada.service';
import { UtilitiesService } from '../../services/utilities.service';
import { SocioService } from '../../services/socio.service';
import { ArticuloService } from '../../services/articulo.service';
import { SubirImagenesService } from '../../services/subir-imagenes.service';
import { DocumentoDetalleEntradaService } from '../../services/documento-detalle-entrada.service';
import { BodegaService } from '../../services/bodega.service';
import { Bodega } from '../../model/bodega';
import { Articulo } from '../../model/articulo';
import { Excepcion } from '../../model/excepcion';
import { ArticuloBuscarComponent } from '../../components/articulo-buscar/articulo-buscar.component';
import { DocumentoGaleriaComponent } from '../../components/documento-galeria/documento-galeria.component';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-documento-entrada-mantenimiento',
  templateUrl: './documento-entrada-mantenimiento.component.html',
  styleUrls: ['./documento-entrada-mantenimiento.component.css']
})
export class DocumentoEntradaMantenimientoComponent implements OnInit {
  @ViewChild(ArticuloBuscarComponent) _articuloBuscar: ArticuloBuscarComponent;
  @ViewChild(DocumentoGaleriaComponent) _galeria: DocumentoGaleriaComponent;


  @Output() onReturn = new EventEmitter();

  public consorcio: Consorcio = new Consorcio();
  public sucursal: Sucursal = new Sucursal();
  public cabecera: DocumentoEntrada = new DocumentoEntrada();

  public _external_codigoDocumento: string;
  public _external_codigoConsorcio: string;
  public _external_codigoSucursal: string;
  public _external_tipoDocumento: string;

  public CargarServiciosEspeciales: boolean;
  public ocultarCabecera: boolean;


  public socios: Socio[];
  public bodegas: Bodega[];
  public socio: Socio;
  public bodega: Bodega;
  public articulo: Articulo;
  public articuloCatalogo: Articulo;

  public detalle: DocumentoDetalleEntrada;
  public detalles: DocumentoDetalleEntrada[];

  public excepcionesDocumento: Excepcion[];

  public agregando: boolean;


  public cargandoImagen: boolean;

  public mostrarDetalle: boolean;
  public mostrarExcepciones: boolean;

  public query: any;

  public ImagenCargada: boolean;
  public NombreImagen: string;
  public archivos: any;
  public archivo: any;
  public imagen: Imagen = new Imagen();
  public imagenes: Imagen[];


  public verImagen: boolean;

  public buscando: boolean = false;

  public editaDetalle: boolean;
  public processedCount: number;
  public totalFiles: number;

  public descripcion: string;


  constructor(
    private _socioService: SocioService,
    private _bodegaService: BodegaService,
    private _documentoEntradaService: DocumentoEntradaService,
    private _detalleService: DocumentoDetalleEntradaService,
    private _subirImagenesService: SubirImagenesService,
    private _articuloService: ArticuloService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.editaDetalle = false;
    this.detalles = [];
    this.CargarServiciosEspeciales = false;

    this.descripcion = "";

    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }

    if (this.articulo === undefined) {
      this.articulo = new Articulo();
    }

    if (this.detalle === undefined) {
      this.detalle = new DocumentoDetalleEntrada();
    }

    this.cargarBodegas();

  }

  cargarServiciosEspeciales() {

    if (this.ocultarCabecera) {
      this.anularCargaServiciosEspeciales();
      return;
    }
    this.ocultarCabecera = true;
    this._external_codigoDocumento = this.cabecera.codigoDocumento;
    this._external_codigoConsorcio = this.cabecera.codigoConsorcio;
    this._external_codigoSucursal = this.cabecera.codigoSucursal;
    this._external_tipoDocumento = "ENTRADA";
    this.CargarServiciosEspeciales = true;
  }

  anularCargaServiciosEspeciales() {
    this.ocultarCabecera = false;
    this.CargarServiciosEspeciales = false;
  }

  regresar() {


    this.CargarServiciosEspeciales = false;
    this.cargandoImagen = false;
    this.onReturn.emit();
  }


  iniciaBusquedaImagen() {

    this.cargandoImagen = !this.cargandoImagen;
    this.CargarServiciosEspeciales = false;

  }

  toggleCabecera() {

    this.CargarServiciosEspeciales = false;
    if (!this.mostrarDetalle) {
      if (this.cabecera.codigoDocumento === undefined) {
        alert("Debe indicar el número de documento");
        return;
      }

      if (this.cabecera.codigoBodega === undefined) {
        alert("Debe seleccionar el almacén");
        return;
      }

    }

    this.cargandoImagen = false;
    this.mostrarDetalle = !this.mostrarDetalle;
    this.mostrarExcepciones = false;

  }

  filtroToggle() {

  }

  agregarDocumento(_consorcio: Consorcio, _sucursal: Sucursal) {

    this.agregando = true;

    this.cabecera.codigoBodega = null;
    this.consorcio = _consorcio;
    this.sucursal = _sucursal;
    this.cabecera = new DocumentoEntrada();
    var date = new Date();
    this.cabecera.codigoDocumento = this.consorcio.documentoPrefijo + "-" + date.getFullYear() + "" + (date.getMonth() + 1) + "" + date.getDate() + "" + date.getHours() + "" + date.getMinutes();
    this.cabecera.codigoBodega = this.consorcio.codigoBodega;
    this.articulo = new Articulo();
    this.detalle = new DocumentoDetalleEntrada();
    this.detalles = [];
    this.cabecera.bultos = 0;
    this.cabecera.kilos = 0;
    this.cabecera.impuestos = 0;
    this.cabecera.valorCIF = 0;

    this.cabecera.estado = "PENDIENTE";

    this.cargarClientes(_consorcio);

  }

  editarDocumento(_consorcio: Consorcio, _sucursal: Sucursal, _cabecera: DocumentoEntrada) {

    this.agregando = false;

    this.consorcio = _consorcio;
    this.sucursal = _sucursal;

    this.cabecera = _cabecera;
    this.cabecera.fecha = this.datePipe.transform(_cabecera.fecha, 'yyyy-MM-dd');
    this.articulo = new Articulo();
    this.detalle = new DocumentoDetalleEntrada();
    this.detalles = [];

    this.cargarClientes(_consorcio);
    this.buscarBodega();
    this.cargarDetalles();

  }

  buscarSocio() {
    for (var i = 0; i <= this.socios.length - 1; i++) {
      if (this.socios[i].codigoSocio === this.cabecera.codigoCliente) {
        this.socio = this.socios[i];
      }
    }
  }

  buscarBodega() {

    for (var i = 0; i <= this.bodegas.length - 1; i++) {
      if (this.bodegas[i].codigoBodega === this.cabecera.codigoBodega) {
        this.bodega = this.bodegas[i];
      }
    }
  }

  eliminarDocumento() {

    if (confirm("¿Realmente desea eliminar el documento: " + this.cabecera.codigoDocumento + " ?")) {

      this._detalleService.deleteAll(this.cabecera).subscribe(
        data => {
          if (data.Resultado === true) {
            alert("Documento eliminado...");
            this.regresar();
          } else {
            alert("Error al eliminar documento");
          }
        },
        err => {
          alert("Error al eliminar documento");
          console.log(err._body);
        });
    }

  }

  ObtenerPesoCostoDetalle(_detalle: DocumentoDetalleEntrada) {

    if (this.consorcio === null) {
      return;
    }

    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "queryText": _detalle.codigoArticulo };

    this._articuloService.getArticuloByCodigo(this.query)
      .subscribe(
        data => {
          _detalle.valorCIF = (((_detalle.cantidad / data[0].unidadesPaquete) + (_detalle.bultos)) * ((this.cabecera.valorCIF + this.cabecera.impuestos) / this.cabecera.bultos));
          _detalle.kilos = (((_detalle.cantidad / data[0].unidadesPaquete) + (_detalle.bultos)) * (this.cabecera.kilos / this.cabecera.bultos));
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }

  cargarDetalles() {

    // var query: any;

    // query = { "codigoConsorcio": this.consorcio.codigoConsorcio, "codigoDocumento": this.cabecera.codigoDocumento };

    this._detalleService.getDetalleByDocumento(this.consorcio.codigoConsorcio, this.cabecera.codigoDocumento)
      .subscribe(
        data => {
          this.detalles = data;
          console.log(data);
        },
        err => {
          console.log(err._body);
        });

    this.editaDetalle = false;
  }

  cargarClientes(_consorcio: Consorcio) {
    this.query = {
      "codigoConsorcio": _consorcio.codigoConsorcio,
      "tipo": "PROVEEDOR"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
        data => {
          this.socios = data;
          this.buscarSocio();
        },
        err => {
          console.clear();
          console.log(err._body);
        });
  }


  cargarBodegas() {
    this._bodegaService.getBodegas()
      .subscribe(
        data => this.bodegas = data,
        err => {
          console.log(err._body);
        });
  }

  seleccionBodega(_bodega: Bodega) {
    this.cabecera.codigoBodega = _bodega.codigoBodega;
  }

  seleccionCliente(_socio: Socio) {
    this.cabecera.codigoCliente = _socio.codigoSocio;
  }

  editarRegistro(detalle: DocumentoDetalleEntrada) {
    this.detalle = detalle;
    this.editaDetalle = true;
    this._articuloBuscar.cargarArticulo(this.detalle.codigoArticulo);
  }

  sumaUnidades() {
    var sumatoria = 0;
    if (this.detalles.length === 0) {
      return sumatoria;
    }
    for (var x = 0; x < this.detalles.length; x++) {
      if (this.detalles[x].cantidad !== null && this.detalles[x].cantidad !== undefined) {
        sumatoria = sumatoria + parseFloat(this.detalles[x].cantidad.toString());
      }
    }
    return sumatoria;
  }

  sumaBultos() {
    var sumatoria = 0;
    if (this.detalles.length === 0) {
      return sumatoria;
    }
    for (var x = 0; x < this.detalles.length; x++) {
      if (this.detalles[x].bultos !== null && this.detalles[x].bultos !== undefined) {
        sumatoria = sumatoria + parseFloat(this.detalles[x].bultos.toString());
      }

    }
    return sumatoria;
  }

  guardar() {

    if (this.cabecera.id === undefined) {
      this.cabecera.id = 0;
    }

    if (this.cabecera.estado === undefined) {
      this.cabecera.estado = 'PENDIENTE';
    }

    if (this.cabecera.referencia1 === undefined) {
      this.cabecera.referencia1 = "";
    }

    if (this.cabecera.referencia2 === undefined) {
      this.cabecera.referencia2 = "";
    }

    if (this.cabecera.referenciaERP === undefined) {
      this.cabecera.referenciaERP = "";
    }

    if (isNullOrUndefined(this.cabecera.factura)) {
      this.cabecera.factura = '';
    }

    if (isNullOrUndefined(this.cabecera.contenedor)) {
      this.cabecera.contenedor = '';
    }

    if (isNullOrUndefined(this.cabecera.comentarios)) {
      this.cabecera.comentarios = '';
    }


    this.cabecera.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.cabecera.codigoSucursal = this.sucursal.codigoSucursal;
    this.cabecera.codigoBodega = this.consorcio.codigoBodega;
    //  this.cabecera.

    this._documentoEntradaService.insert(this.cabecera).subscribe(
      result => {
        {
          if (result.Resultado === "codigoDocumento ya existe en la base de datos") {
            alert("El código del Documento ya existe");
          } else {
            if (result.Resultado === false) {
              alert("Ha ocurrido un error...");
            } else {
              this.guardarDetalles();
            }
          }
        }

      },
      err => {
        console.log(err._body);
      });


  }


  articuloSeleccionado($event) {
    this.articulo = $event;
    if (!this.editaDetalle) {
      this.detalle.bultos = 0;
      this.detalle.cantidad = 0;
    }
  }

  guardarDetalle() {

    var agregar: boolean;
    if (this.detalles.length > 0) {
      if ((this.detalle.id === 0) || (this.detalle.id === undefined)) {
        this.detalle.id = Math.max.apply(Math, this.detalles.map(function (o) { return o.id; })) + 1;
        agregar = true;
      }
    } else {
      agregar = true;
      this.detalle.id = 1;
    }

    this.detalle.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.detalle.codigoDocumento = this.cabecera.codigoDocumento;
    this.detalle.codigoArticulo = this.articulo.codigoArticulo;
    this.detalle.nombreArticulo = this.articulo.nombreLargo;

    if (isNullOrUndefined(this.detalle.idLinea)) {
      this.detalle.idLinea = this.detalles.length;
    } else {
      this.detalle.idLinea = this.detalle.idLinea;
    }


    this.detalle.fecha = this.cabecera.fecha;
    this.detalle.dua = this.cabecera.dua;
    this.detalle.contenedor = this.cabecera.contenedor;
    this.detalle.movInv = this.cabecera.movInv;
    this.detalle.factura = this.cabecera.factura;
    this.detalle.listaEmpaque = this.cabecera.listaEmpaque;
    this.detalle.impuestos = 0;

    if (isNullOrUndefined(this.detalle.dua)) {
      this.detalle.dua = '';
    }
    if (isNullOrUndefined(this.detalle.contenedor)) {
      this.detalle.contenedor = '';
    }
    if (isNullOrUndefined(this.detalle.movInv)) {
      this.detalle.movInv = '';
    }
    if (isNullOrUndefined(this.detalle.factura)) {
      this.detalle.factura = '';
    }
    if (isNullOrUndefined(this.detalle.listaEmpaque)) {
      this.detalle.listaEmpaque = '';
    }
   

    //this.ObtenerPesoCostoDetalle(this.detalle);


    this.detalle.kilos = (((parseInt(this.detalle.cantidad.toString()) / parseInt(this.articulo.unidadesPaquete.toString())) + (parseInt(this.detalle.bultos.toString()))) * (parseFloat(this.cabecera.kilos.toString()) / parseInt(this.cabecera.bultos.toString())));

    this.detalle.valorCIF = (((parseInt(this.detalle.cantidad.toString()) / parseInt(this.articulo.unidadesPaquete.toString())) + (parseInt(this.detalle.bultos.toString()))) * ((parseFloat(this.cabecera.valorCIF.toString()) + parseFloat(this.cabecera.impuestos.toString())) / parseInt(this.cabecera.bultos.toString())));

    if (this.detalle.lote === undefined) {
      this.detalle.lote = "";
    }

    if (this.detalle.referencia1 === undefined) {
      this.detalle.referencia1 = "";
    }

    if (this.detalle.referencia2 === undefined) {
      this.detalle.referencia2 = "";
    }

    if (this.detalle.comentarios === undefined) {
      this.detalle.comentarios = "";
    }
    if (isNullOrUndefined(this.detalle.kilos) || isNaN(this.detalle.kilos)) {
      this.detalle.kilos = 0;
    }
    if (isNullOrUndefined(this.detalle.valorCIF) || isNaN(this.detalle.valorCIF)) {
      this.detalle.valorCIF = 0;
    }
 

    if (agregar) {
      this.detalles.push(this.detalle);
    }

    this.detalle = new DocumentoDetalleEntrada();
    this._articuloBuscar.limpiarDatos();
    this.articulo = new Articulo();

    this.editaDetalle = false;


  }

  guardarDetalles() {

  //  for (var i = 0; i <= this.detalles.length - 1; i++) {

      this._detalleService.insert(this.detalles).subscribe(
        result => {

          if (result.tipoResultado === 'ERROR') {
            alert('Ha ocurrido un error en la inserción de los detalles');
            console.log(result);
          }


        },
        err => {
          console.log(err._body);
        });
   // }
    this.regresar();
  }


  aprobarDocumento() {
    if (confirm("Desea aprobar el documento: " + this.cabecera.codigoDocumento)) {

      //   this.query = { "codigoDocumento": this.cabecera.codigoDocumento, "codigoConsorcio": this.consorcio.codigoConsorcio, "estado": "APROBADO" };

      console.log(this.query);

      this._documentoEntradaService.aprobar(this.cabecera.codigoBodega,
        this.cabecera.codigoConsorcio, this.cabecera.codigoSucursal, this.cabecera.codigoDocumento).subscribe(
          result => {
            console.clear();
            console.log("========= APROBACION DE DOCUMENTOS ===============");
            console.log(result);

            if (result.tipoResultado === 'OK') {
              this.regresar();
            } else {
              alert('Ha ocurrido un error, ' + result.mensaje);
            }


          },
          err => {
            console.log(err._body);
          });
    }
  }



  ActualizarDatos() {
    if (confirm("Desea actualizar la información del documento? " + this.cabecera.codigoDocumento)) {

      //this.query = { "codigoDocumento": this.cabecera.codigoDocumento, "codigoConsorcio": this.consorcio.codigoConsorcio, "estado": "APROBADO" };

      this.query =
      {
        codigoDocumento: this.cabecera.codigoDocumento,
        mov_inv: this.cabecera.movInv,
        factura: this.cabecera.factura,
        contenedor: this.cabecera.contenedor,
        dua: this.cabecera.dua,
        codigoConsorcio: this.consorcio.codigoConsorcio,
        referencia1: this.cabecera.referencia1,
        referencia2: this.cabecera.referencia2,
        referenciaERP: this.cabecera.referenciaERP
      }

      console.log(this.query);

      this._documentoEntradaService.actualizar(this.query).subscribe(
        result => {
          console.clear();
          console.log("============[ ACTUALIZACIÓN DE DOCUMENTOS ]===============");
          console.log(result);
          this.regresar();
        },
        err => {
          console.log(err._body);
        });
    }
  }

  /*
    Cargar archivo
   
  */


  onChangeFile(event) {
    this.ImagenCargada = true;
    var files = event.target.files || event.srcElement.files;
    this.NombreImagen = files.length;
    this.archivos = files;
    this.processedCount = 0;
    this.totalFiles = 0;
  }

  convertirImagen(index) {

    this.totalFiles = (this.archivos.length - 1);

    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {

      this.imagen.base64 = myReader.result;
      this.imagen.descripcion = this.descripcion === "" || this.descripcion === null ? "Sin Descripción" : this.descripcion;
      this.imagen.codigoDocumento = this.cabecera.codigoDocumento;
      this.imagen.tipoDocumento = "SALIDA";

      this.imagenes.push(this.imagen);

      this.imagen = new Imagen();

      if (this.totalFiles === this.processedCount) {
        this._subirImagenesService.upload(this.imagenes).subscribe(
          result => {
            alert("Imágenes Guardadas");
            this.buscando = false;
            this.imagen = new Imagen();
            this.imagenes = [];
            this.cargandoImagen = false;
            this.archivo = null;
          },
          err => {
            console.log(err._body);
          });

      } else {
        this.processedCount++;
        this.convertirImagen(this.processedCount);
      }

    }

    myReader.readAsDataURL(this.archivos[index]);

  }

  buscarImagen() {
    if (this.cabecera.id === null || this.cabecera.id === undefined || this.cabecera.id === 0) {
      return;
    }
    document.getElementById("Button_File_Image").click();
  }

  cargarArchivo() {
    try {

      this.imagenes = [];
      this.buscando = true;
      this.totalFiles = this.archivos.files;
      this.processedCount = 0;
      this.convertirImagen(0);

    } catch (e) {
      console.log(e);
    }
  }

  verGaleria() {

    this.CargarServiciosEspeciales = false;
    console.clear();
    console.log(this.cabecera.codigoDocumento);
    this._galeria.cargarImagenesDocumento(this.cabecera.codigoDocumento, 'ENTRADA');
    this.verImagen = true;
  }

  verDocumento() {
    this.verImagen = false;
  }

  eliminarLinea(id: number) {
    if (confirm("¿Desea borrar la linea?")) {
      let index = -1;
      for (var i = 0; i < this.detalles.length; i++) {
        if (this.detalles[i].id === id) {
          index = i;
          break;
        }
      }
      this._detalleService.delete(this.detalle)
        .subscribe(
          data => {
            console.log(data);
            this.detalles = this.detalles.splice(index);
            if (this.detalles.length > 0) {
              this.cargarDetalles();
            }
            alert("Linea eliminada con éxito");
          },
          err => {
            console.log(err._body);
          });

      this.editaDetalle = false;
    }
  }


}





// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-entrada-mantenimiento/documento-entrada-mantenimiento.component.ts